// Здесь также может быть нужна функция $(fieldset).data, которую вам надо заменить на нативный подход хранения данных.
// Можно использовать WeakMap или data-* атрибуты.

import { findDifferences } from "../../utils/dataUtils";
import { previewImage } from "../../utils/domUtils";

const fieldsetDataMap = new WeakMap();

export function updateDataAll(fieldset) {
  const newData = collectDataFromElements(fieldset);
  updateData(fieldset, newData);
}

export function hardUpdateDataAll(fieldset) {
  const newData = collectDataFromElements(fieldset);
  hardUpdateData(fieldset, newData);
}

export function hardUpdateData(fieldset, newData) {
  const oldData = getFieldsetData(fieldset);
  const diff = findDifferences(oldData, newData);
  setFieldsetData(fieldset, newData);
  triggerCustomEvent(fieldset, newData, diff);
}

export function updateData(fieldset, newData) {
  const oldData = getFieldsetData(fieldset);
  if (JSON.stringify(newData) === JSON.stringify(oldData)) return;

  const diff = findDifferences(oldData, newData);
  setFieldsetData(fieldset, newData);
  triggerCustomEvent(fieldset, newData, diff);
}

export function setFieldsetData(fieldset, data) {
  fieldset.data = data;
  fieldsetDataMap.set(fieldset, data);
}

export function getFieldsetData(fieldset) {
  return fieldsetDataMap.get(fieldset) || {};
}

export function setData(fieldset, data) {
  if (!fieldset || typeof data !== 'object') return;

  for (const key in data) {
    const keys = key.match(/[^\[\]]+(?=\])?/g) || [key];
    const value = data[key];

    let selector = keys.reduce((acc, k, index) => {
      return acc + (index === 0 ? `[name="${k}"]` : `[${k}]`);
    }, '');

    const element = fieldset.querySelector(selector);

    if (element) {
      if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT') {
        if (element.type === 'checkbox' || element.type === 'radio') {
          element.checked = !!value;
        } else {
          element.value = value;
        }
      }
    } else {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = key;
      hiddenInput.value = value;
      fieldset.appendChild(hiddenInput);
    }
  }

  fieldset.updateData();
}


export function fildsetInit(fieldset) {
  fieldset.updateData = () => updateDataAll(fieldset);
  fieldset.hardUpdateData = () => hardUpdateDataAll(fieldset);
  fieldset.updateInputNames = (options = {}) => updateInputNames(fieldset, options);
  fieldset.deleteRow = (row, options = {}) => deleteRow(fieldset, row, options);
  fieldset.moveRow = (row, direction, options = {}) => moveRow(fieldset, row, direction, options);
  fieldset.set = (data) => setData(fieldset, data);
  fieldset.updateFileInputs = (filesObj) => updateFileInputs(fieldset, filesObj);

  if (!fieldset.hasAttribute('disabled')) fieldset.updateData();

  fieldset.addEventListener('fieldsetUpdated', _debouncedSendData(fieldset));

}

export function _debouncedSendData(fieldset) {
  return debounce(() => _sendData(fieldset), 500);
}


function _sendData(fieldset, path = null) {
  const saveUrl = path ?? fieldset.dataset.myFieldsetSave;
  if (saveUrl) {
    return new SendData({
      data: getDataAll(fieldset),
      url: saveUrl
    });
  }
}

export function collectDataFromElements(fieldset) {
  if (!fieldset || !fieldset.elements) {
    return {};
  }
  return fieldsetDataToObject(
    Array.from(fieldset.elements).reduce((acc, el) => {
      if (el.closest('fieldset[disabled]')) return acc;
      if (!el.name || el.disabled) {
        return acc;
      }
      let value;
      switch (el.type) {
        case 'checkbox':
        case 'radio':
          value = el.checked ? (el.value || true) : false;
          break;
        case 'file':
          value = el.files ? el.files : null;
          break;
        default:
          value = el.value;
          break;
      }

      if (value !== null) {
        if (el.type === 'file') {
          if (!acc._FILES) acc._FILES = {};
          if (typeof acc._FILES[el.name] !== 'undefined') {
            acc._FILES[el.name] = [].concat(acc._FILES[el.name], value);
          } else {
            acc._FILES[el.name] = value;
          }
        } else {
          if (value === false && el.type === 'checkbox' && el.closestAttribute('data-cheackbox-set')) return acc;
          if (typeof acc[el.name] !== 'undefined') {
            if (el.type === 'radio') {
              if (value !== false) acc[el.name] = value;
            } else acc[el.name] = [].concat(acc[el.name], value);
          } else if (el.type === 'checkbox' && el.closestAttribute('data-cheackbox-set')) {
            acc[el.name] = [value];
          } else {
            acc[el.name] = value;
          }
        }
      }

      return acc;
    }, {})
  );
}

/**
 * Проверяет, является ли элемент защищённым (norekay на самом элементе или на дочерних)
 */
function _isNorekay(element) {
  return element.hasAttribute('norekay') || !!element.querySelector('[norekay]');
}

export function updateInputNames(fieldset, options = {}) {
  const { selector = '.row', key = null } = options;

  const rows = fieldset.querySelectorAll(selector);

  // Собираем индексы, занятые norekay-элементами
  const reservedIndices = new Set();
  rows.forEach((element) => {
    if (_isNorekay(element)) {
      // Определяем текущий индекс norekay-элемента из первого input/select
      const firstInput = element.querySelector('input[norekay], select[norekay]') || element.querySelector('input, select');
      if (firstInput) {
        let currentIndex = null;
        if (key) {
          const regex = new RegExp(`\\[${key}\\]\\[(\\d+)\\]`);
          const m = firstInput.name.match(regex);
          if (m) currentIndex = parseInt(m[1], 10);
        } else {
          const m = firstInput.name.match(/^[^\[]*\[(\d+)\]/);
          if (m) currentIndex = parseInt(m[1], 10);
        }
        if (currentIndex !== null) reservedIndices.add(currentIndex);
      }
    }
  });

  // Назначаем индексы: norekay — оставляем как есть, остальным — следующий свободный
  let freeIndex = 0;
  rows.forEach((element) => {
    if (_isNorekay(element)) return; // Не трогаем norekay

    // Пропускаем зарезервированные индексы
    while (reservedIndices.has(freeIndex)) freeIndex++;

    const currentIdx = freeIndex;
    freeIndex++;

    element.querySelectorAll('input, select').forEach((inputElement) => {
      if (key) {
        const regex = new RegExp(`(\\[${key}\\])\\[(\\d+)\\]`);
        inputElement.name = inputElement.name.replace(regex, `$1[${currentIdx}]`);
      } else {
        const match = inputElement.name.match(/^([^\[]*)\[(\d+)\](.*)$/);
        if (match) {
          inputElement.name = match[1] + `[${currentIdx}]` + match[3];
        }
      }
    });
  });

  fieldset.updateData();
}

/**
 * Удаляет строку из таблицы и переиндексирует остальные
 * @param {HTMLElement} fieldset - форма
 * @param {HTMLElement} row - строка для удаления
 * @param {Object} options - { selector: '.row', key: 'actions' }
 */
export function deleteRow(fieldset, row, options = {}) {
  const { selector = '.row', key = null } = options;

  if (!row) return;

  row.remove();
  fieldset.updateInputNames(options);
}

/**
 * Перемещает строку вверх или вниз
 * @param {HTMLElement} fieldset - форма
 * @param {HTMLElement} row - строка для перемещения
 * @param {String} direction - 'up' или 'down'
 * @param {Object} options - { selector: '.row', key: 'actions' }
 */
export function moveRow(fieldset, row, direction, options = {}) {
  const { selector = '.row', key = null } = options;

  if (!row || _isNorekay(row)) return; // norekay нельзя перемещать

  const rows = Array.from(fieldset.querySelectorAll(selector));
  const currentIndex = rows.indexOf(row);

  if (direction === 'up') {
    // Ищем ближайший не-norekay элемент выше
    let targetIndex = currentIndex - 1;
    while (targetIndex >= 0 && _isNorekay(rows[targetIndex])) targetIndex--;
    if (targetIndex >= 0) {
      rows[targetIndex].insertAdjacentElement('beforebegin', row);
    }
  } else if (direction === 'down') {
    // Ищем ближайший не-norekay элемент ниже
    let targetIndex = currentIndex + 1;
    while (targetIndex < rows.length && _isNorekay(rows[targetIndex])) targetIndex++;
    if (targetIndex < rows.length) {
      rows[targetIndex].insertAdjacentElement('afterend', row);
    }
  }

  fieldset.updateInputNames(options);
}

function fieldsetDataToObject(data) {
  const result = {};
  for (let key in data) {
    let keys = key.match(/[^\[\]]+(?=\])?/g) || [key];
    const baseName = keys[0];

    // Если это простой ключ (без индекса) и уже есть объект/массив с таким именем
    if (keys.length === 1 && typeof result[baseName] === 'object' && result[baseName] !== null) {
      // Добавляем значение как следующий элемент массива
      if (Array.isArray(result[baseName])) {
        result[baseName].push(data[key]);
      } else {
        // Преобразуем объект в массив и добавляем новое значение
        const existingValues = Object.values(result[baseName]);
        result[baseName] = [...existingValues, data[key]];
      }
      continue;
    }

    keys.reduce((acc, nextKey, index) => {
      try {
        if (index === keys.length - 1) {
          acc[nextKey] = data[key];
        } else {
          acc[nextKey] = acc[nextKey] || {};
        }
      } catch (error) {
        debugger;
      }
      return acc[nextKey];
    }, result);
  }
  return convertObjectsToArrays(result);
}

function convertObjectsToArrays(obj) {
  for (let key in obj) {
    if (obj[key] !== null && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      if (obj[key] instanceof File || obj[key] instanceof FileList) {
        continue;
      }
      obj[key] = convertObjectsToArrays(obj[key]);
      if (allKeysAreSequentialNumbers(obj[key])) {
        obj[key] = Object.keys(obj[key]).map((index) => obj[key][index]);
      }
    }
  }
  return obj;
}

function allKeysAreSequentialNumbers(obj) {
  let keys = Object.keys(obj).map(Number);
  if (keys.some(isNaN)) return false;
  return keys.sort((a, b) => a - b).every((value, index) => value === index);
}

/**
 * Обновляет file input-ы из объекта _FILES
 * Принимает объект вида { photo: FileList, testContainer: { test: FileList } }
 * Находит соответствующие input[type="file"] и устанавливает их files
 * После установки вызывает previewImage на каждом обновлённом input
 */
export function updateFileInputs(fieldset, filesObj) {
  if (!filesObj || typeof filesObj !== 'object') return;
  if (!fieldset) return;

  const mappings = _mapFilesToInputs(filesObj);

  mappings.forEach((map) => {
    if (!map) return;
    const { selector, fileList } = map;
    if (!selector || !fileList) return;

    const input = fieldset.querySelector(selector);
    if (!input || input.type !== 'file') return;

    try {
      // Создаём DataTransfer чтобы корректно установить FileList
      const dt = new DataTransfer();
      Array.from(fileList).forEach((f) => dt.items.add(f));
      input.files = dt.files;

      // Вызываем previewImage для обновлённого input
      previewImage(input);
    } catch (e) {
      // Fallback для старых браузеров
      try {
        input.files = fileList;
        previewImage(input);
      } catch (err) {
        console.warn('Не удалось установить input.files для', selector, err);
      }
    }
  });

  // После установки файлов обновляем данные fieldset
  if (fieldset && typeof fieldset.updateData === 'function') {
    fieldset.updateData();
  }
}

/**
 * Рекурсивно пробегает объект _FILES и возвращает массив маппингов { selector, fileList }
 * Пример входа: { photo: FileList, testContainer: { test: FileList } }
 * Результат: [ { selector: 'input[name="photo"]', fileList }, { selector: 'input[name="testContainer[test]"]', fileList } ]
 */
function _mapFilesToInputs(filesObj, prefix = '') {
  if (!filesObj || typeof filesObj !== 'object') return [];

  const results = [];

  Object.keys(filesObj).forEach((key) => {
    const value = filesObj[key];
    const currentPath = prefix ? `${prefix}[${key}]` : key;

    // Проверяем, является ли value FileList или массивом файлов
    const isFileList = value instanceof FileList || (Array.isArray(value) && value.length && value[0] instanceof File);
    const isFileListLike = isFileList || (value && value.length && value[0] && value[0].name && value[0] instanceof File);

    if (isFileList || isFileListLike) {
      const selector = `input[name="${currentPath}"]`;
      results.push({ selector, fileList: value });
    } else if (value && typeof value === 'object') {
      // Рекурсивно пробегаем вложенный объект
      const nested = _mapFilesToInputs(value, currentPath);
      nested.forEach((n) => results.push(n));
    }
  });

  return results;
}

function triggerCustomEvent(fieldset, data, diff) {
  if (!fieldset || !fieldset.elements) {
    return false;
  }

  const fieldsetUpdatedEvent = new CustomEvent('fieldsetUpdated', {
    detail: { data, fieldset, diff, target: fieldset },
    bubbles: true,
    cancelable: true,
    target: fieldset
  });

  fieldset.dispatchEvent(fieldsetUpdatedEvent);
}
